<template>
    <span v-b-tooltip.hover title="Open Codelab">
        <a :href="resourceUrl" target="_blank">
            <i class="open-resource fa fa-link pointer-action" variant="warning"></i
        ></a>
    </span>
</template>

<script>
export default {
    props: {
        resourceUrl: {
            required: true,
            type: String,
        },
    },
}
</script>

<style></style>
